module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAUCAYAAACNiR0NAAABIUlEQVQ4jZ2VPS8FURCGH1wRvUJEchNq8ZUoJaor21KrtEoSoaHSUNEoNX4BQuMv+KpU/oOEBMkrk+xJTtae4855k9lmzr5nnp2Z7IAkai0DG0AHuARuKZEZSjrUX53VOVfYY6HFLGjdazgIbGfAKi+0GY78k3cbvmbyV15D4+4lvt9FaVM6kr4aZlslZqEpP8Bjo/CuGzVCtthsQZ4uqTBsyijwDgxFd1nVc94Cw1h8AjuN3CxwWooc4rkF/TyBNy5pT9KxpKW4y3FMJkboRtJEdK6S9NE4c9JmaLGaMP2WtC9pJZE3raW6VWVeyukutavXwDzw4mzJcG75H4AZYNdheN/vwHYlHUl6y+A+2RrHv4B+tQj0gClgzCavpjkA+AVji7+hA9DTCwAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/rightNav/right002.png
// module id = SAQW
// module chunks = 1